export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS'
export const NOTIFICATION_WARNING = 'NOTIFICATION_WARNING'
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR'
export const NOTIFICATION_RESET = 'NOTIFICATION_RESET'
export const NOTIFICATION_CLICKED = 'NOTIFICATION_CLICKED'



// WEBPACK FOOTER //
// ./app/actions/notifications/constants.js